import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Quiz } from '../models';

export const quizActions = createActionGroup({
    source: 'Quiz',
    events: {
        'Get Quiz': props<{ id: string }>(),
        'Get Quiz Success': props<{ payload: Quiz }>(),
        'Get Quiz Error': props<{ id: string; code: number }>(),

        Clear: props<{ id: string }>(),
        'Clear All': emptyProps(),
    },
});
